// -1500待绑车，0订单待确认，1000订单待支付，1500发车待验车，2500履约中，3500退车待验车，4500订单待核算，5000费用待结算，5500已关闭
export const ORDER_STATE = {
  TO_BIND: -1500,
  TO_CONFIRM: 0,
  TO_PAY: 1000,
  TO_CHECK_FOR_SEND: 1500,
  RENTING: 2500,
  TO_CHECK_FOR_RETURN: 3500,
  TO_BILL: 4500,
  TO_SETTLEMENT: 5000,
  CLOSED: 5500,
}
